import { navigate } from "gatsby";
import React from "react";
import { Provider } from "react-redux";
import { AdminLayout } from "./src/components/index";
import Layout from "./src/components/Web/Layout";
import { AuthProvider } from "./src/context/AuthContext";
import store from "./src/redux";
import "./src/styles/global.css";

declare global {
  interface Window {
	___navigate?: (path: string, options?: { replace?: boolean }) => void
  }
}

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
	return <Provider store={store}>{element}</Provider>
}

// Wrap Page Element for Layout
import type { PageProps } from "gatsby";

export const wrapPageElement = ({ element, props, }: { element: React.ReactNode; props: PageProps; }) => {
	const path = props.location.pathname
	if (path.startsWith('/admin')) {
		return( <AuthProvider><AdminLayout>{element}</AdminLayout></AuthProvider>)
	}else{
		return(<AuthProvider><Layout {...props}>{element}</Layout></AuthProvider>)
	}
}
			// {/* <Layout {...props} language={language}>{element}</Layout> */}
// Original code before Sofia and it was workng fine
// export const onClientEntry = () => {
// 	if (typeof window !== 'undefined') {
// 		const savedLanguage = localStorage.getItem('preferredLanguage') || 'en'
// 		if (window.location.pathname === '/') {
// 			if(savedLanguage !== 'en') {
// 				const targetPath = `/${savedLanguage}/`
// 				if (window.location.pathname !== targetPath){
// 					setTimeout(() => {
// 						if (typeof window.___navigate === "function") {
// 							(navigate as unknown as (path: string, options?: { replace?: boolean }) => void)(`/${savedLanguage}/`)
// 						} else {
// 							console.warn("Gatsby navigation is not yet initialized.")
// 						}
// 					}, 0)
// 				}
// 			}
// 		}
// 	}
// }















// Sofia's code to fix the issue of redirection loop on homepage when language is not English
// export const onClientEntry = () => {
//   if (typeof window === "undefined") return;

//   const savedLanguage = localStorage.getItem("preferredLanguage") || "en";
//   const category = localStorage.getItem("salonCategory");
//   const currentPath = window.location.pathname;

//   // Helper: safe navigate
//   const safeNavigate = (targetPath: string) => {
//     setTimeout(() => {
//       if (typeof window.___navigate === "function") {
//         (navigate as unknown as (path: string, options?: { replace?: boolean }) => void)(targetPath);
//       } else {
//         console.warn("Gatsby navigation not initialized yet. Retrying...");
//         setTimeout(() => {
//           if (typeof window.___navigate === "function") {
//             (navigate as unknown as (path: string, options?: { replace?: boolean }) => void)(targetPath);
//           } else {
//             console.error("Navigation still not available — skipped redirect to:", targetPath);
//           }
//         }, 100);
//       }
//     }, 0);
//   };

//   // --- Salon category logic ---
//   if (currentPath === "/") {
//     if (!category) {
//       safeNavigate("/select-category");
//       return;
//     } else {
//       safeNavigate(`/home/${category.toLowerCase()}`);
//       return;
//     }
//   }

//   // --- Language logic ---
//   if (currentPath === "/" && savedLanguage !== "en") {
//     const targetPath = `/${savedLanguage}/`;
//     if (currentPath !== targetPath) {
//       safeNavigate(targetPath);
//     }
//   }
// };



export const onRouteUpdate = ({ location }: { location: { pathname: string } }) => {
	const path = location.pathname
	if (path.startsWith("/en")) {
		let newPath = path.replace(/^\/en/, "/");
		newPath = newPath.replace('//', '/')
		if (newPath !== path) {
			(navigate as unknown as (path: string, options?: { replace?: boolean }) => void)(newPath, { replace: true });
		}
	}
};